import {gsap} from "gsap";
import {DrawSVGPlugin} from "gsap/DrawSVGPlugin";
import {MorphSVGPlugin} from "gsap/MorphSVGPlugin";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";

gsap.registerPlugin(DrawSVGPlugin, MorphSVGPlugin, ScrollTrigger, ScrollToPlugin);

jQuery(document).ready(function () {

    if( jQuery('.horizontal-container').length > 0 ){
        let container = document.querySelector('.horizontal-container');

        let padding = (window.innerWidth - jQuery(container).width()) + 150;
        jQuery(container).find('.horizontal-elements').css('padding-right',padding);

        ScrollTrigger.create({
            trigger: ".js-horizontal-scroll",
            start: "bottom bottom",
            end: () => "+=" + (container.scrollWidth - window.innerWidth),
            pin: '#page-content',
            anticipatePin: 1,
            scrub: 0.5,
            invalidateOnRefresh: true,
            // markers: true,
        })

        let thumbNails = gsap.utils.toArray(".horizontal-element");
        thumbNails.forEach((thumb, i) => {
            gsap.to(thumb, {
                x: () => {
                    return -(container.scrollWidth - window.innerWidth)
                },
                ease: "none",
                scrollTrigger: {
                    trigger: ".horizontal-wrapper",
                    start: 'bottom bottom',
                    scrub: 0.5,
                    invalidateOnRefresh: true,
                    end: () => "+=" + (container.scrollWidth - window.innerWidth)
                }
            });
        });
    }

});
